
<template>
	<v-dialog
			:value="isViewSelectedFilePPW"
			content-class="dialogWrapper"
			persistent
			width="840"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View PPW file</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<main-table
						padding="0"
						:flag="flag"
						:headers="getHeaders"
						:listItems="items"
						@updateClickButton="onClickButton($event, flag)"
						:is-hide-header="false"
						:items-per-page-amount="10"
						:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				></main-table>
			</div>
		</div>
	</v-dialog>
</template>

<script>
import { tableViewPPWFiles } from "@/components/Dispatch/Trips/DialogTrip/constants";

export default {
	name: "ViewSelectedPPWFiles",
	props: {
		items: Array,
	},
	computed: {
		getHeaders() {
			return tableViewPPWFiles;
		},
		isDisabled() {
			return this.selected.length === 0;
		},
	},
	data: () => ({
		flag: 'ViewSelectedPPWFiles',
		isViewSelectedFilePPW: true,
	}),
	methods: {
		onClickButton({ key, item }, nameComponent) {
			this.$emit('updatePPWFilesClickButton', { key, item, nameComponent });
		},
		onClose() {
			this.$emit('updateClose');
		},
	}
};
</script>

<style scoped lang="scss">
@import "../../dialog";
.dialogWrapper {
	.dialogMain {
		margin-bottom: 0;
	}
}
</style>
